// @flow
import MainActions from 'esm-web-pro/components/layout/sidePanel/MainActions';
import * as React from 'react';
import TimelineIcon from 'esm-web-pro/components/layout/sidePanel/icons/TimelineIcon';
import { IntlShape, injectIntl } from 'react-intl';
import type { Match, RouterHistory } from 'react-router-dom';
import { withRouter } from 'react-router';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import type { FiberDetailedRepresentation } from 'esm-web-pro/types/networks';
import FiberDamageAction from 'esm-web-pro/containers/pages/network/objects/fiber/FiberDamageAction';
import type { Map } from 'esm-web-pro/containers/map/types';

type Props = {
    fiber: FiberDetailedRepresentation,
    map: Map,
    history: RouterHistory,
    match: Match,
    intl: IntlShape,
    updateObject: (data: FiberDetailedRepresentation) => void,
    editor: Object,
}

const FiberActions = (props: Props) => {
    const {
        fiber, history, match, intl: { formatMessage },
        map,
        updateObject, editor,
    } = props;

    const regex = /^(.+?)(\/+)$/gm;
    const actions = [
        {
            key: `${fiber.id}-timeline`,
            icon: <TimelineIcon />,
            tooltip: formatMessage(actionMessages.timeline),
            callback: () => history.push(`${match.url.replace(regex, '$1')}/timeline/fiber/${fiber.identity}`),
            marginVertical: '15px',
            radius: '0%',
            color: 'transparent',
        },
    ];

    return (
        <>
            <FiberDamageAction
                fiber={fiber}
                updateObject={updateObject}
                map={map}
                main
                ActionComponent={MainActions}
                pad="0px"
                editor={editor}
            />
            <MainActions main actions={actions} />
        </>
    );
};

export default withRouter(injectIntl(FiberActions));
